import { render, staticRenderFns } from "./v-pagination.vue?vue&type=template&id=58c7dc98&scoped=true&"
import script from "./v-pagination.vue?vue&type=script&lang=js&"
export * from "./v-pagination.vue?vue&type=script&lang=js&"
import style0 from "./v-pagination.vue?vue&type=style&index=0&id=58c7dc98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c7dc98",
  null
  
)

export default component.exports